import { Modal } from "react-bootstrap";
import { useMerchant } from "../context/merchant";
import { useEffect, useRef } from "react";

// Autoplay хаагдсан үед дууг дахин оролдох хэрэглэгчийн үйлдлүүд
// (touchend/click/keydown нь хөтөчид "user activation" болдог).
const GESTURE_EVENTS = ["click", "touchend", "keydown"];

export default function NewOrderModal({ show, handleClose, onClick }) {
  const { isFullScreen, newOrderCount, newOrderTick } = useMerchant();

  const audioRef = useRef(null);

  // ⚠️ Хөтчийн autoplay бодлого: товшилтгүйгээр `play()` дуудвал NotAllowedError-оор
  //    хориглодог — ОРДЕР ирэх бүрд дуу чимээгүй байв. authExpiredOverlay.js-ийн арга:
  //    эхлээд play() оролдож, хоригдвол ДЭЛГЭЦЭД ХҮРМЭГЦ (gesture) дахин тоглуулна.
  //    `newOrderTick` deps — modal аль хэдийн нээлттэй байхад шинэ захиалгад ДАХИН дуугарна.
  useEffect(() => {
    if (!show) return undefined;

    let cancelled = false;
    const audio = new Audio("/assets/sound/ringtone.mp3");
    audio.loop = true;
    audioRef.current = audio;

    function handleGesture() {
      if (cancelled) return;
      Promise.resolve(audio.play()).then(removeGestureListeners).catch(() => {});
    }
    function removeGestureListeners() {
      GESTURE_EVENTS.forEach((t) => document.removeEventListener(t, handleGesture, true));
    }

    Promise.resolve(audio.play()).catch((e) => {
      if (cancelled) return;
      console.log("Audio play error:", e);
      GESTURE_EVENTS.forEach((t) => document.addEventListener(t, handleGesture, true));
    });

    return () => {
      cancelled = true;
      removeGestureListeners();
      audio.pause();
      audio.currentTime = 0;
      if (audioRef.current === audio) audioRef.current = null;
    };
  }, [show, newOrderTick]);

  const handleCloseWithAudioStop = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current = null;
    }
    handleClose();
  };

  const handleOnClickWithAudioStop = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current = null;
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <Modal
      show={show}
      onExited={handleOnClickWithAudioStop}
      onHide={handleCloseWithAudioStop}
      centered
      backdrop="static"
    >
      <Modal.Header
        closeButton
        className="modal-filled bg-danger border-0"
      ></Modal.Header>
      <Modal.Body className="modal-filled bg-danger">
        <div className="text-center">
          <div
            className="avatar-xl rounded m-auto"
            style={{ height: "10rem", width: "10rem" }}
          >
            <span className="avatar-title bg-white border rounded-circle h3 my-0">
              <h1 className="text-danger" style={{ fontSize: "5rem" }}>
                {newOrderCount}
              </h1>
            </span>
          </div>
          <h4 className={`my-3 ${isFullScreen && "fs-3"}`}>
            Шинэ захиалга ирлээ
          </h4>
          <button
            type="button"
            className={`btn btn-light my-2 ${isFullScreen && "btn-lg"}`}
            onClick={handleCloseWithAudioStop}
          >
            Захиалга харах
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
